import * as Yup from 'yup';

export const validationsvideoCall = Yup.object({
    type_identification: Yup.string().required(
        'El tipo de identificación es obligatorio'
    ),
    identification: Yup.string().required('La identificación es obligatoria'),
    name: Yup.string()
        .required('El nombre es obligatorio')
        .matches(/^[A-Za-z]+$/, 'El nombre solo puede contener letras')
        .test(
            'NoNumbers',
            'El nombre no puede contener números',
            (value) => !/\d/.test(value)
        ),
    surname: Yup.string()
        .required('El apellido es obligatorio')
        .matches(/^[A-Za-z]+$/, 'El apellido solo puede contener letras')
        .test(
            'NoNumbers',
            'El apellido no puede contener números',
            (value) => !/\d/.test(value)
        ),
    email: Yup.string()
        .email('El correo es inválido')
        .required('El correo es obligatorio')
        .test('Validate Email', 'El correo es inválido', (value) => {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }),
    cell: Yup.string()
        .matches(/^[0-9]*$/, 'El número de celular solo puede contener números')
        .required('El número de celular es obligatorio'),
    acceptPolicy: Yup.boolean()
        .oneOf(
            [true],
            'Debe aceptar la política de privacidad y uso de datos personales'
        )
        .required(
            'Debe aceptar la política de privacidad y uso de datos personales'
        ),
});

export const valuesvideoCall = {
    type_identification: '',
    name: '',
    surname: '',
    email: '',
    identification: '',
    cell: '',
    acceptPolicy: false,
};
